import axios from 'axios';

const axiosWithXsrf = axios.create({
  xsrfHeaderName: 'X-XSRF-TOKEN',
  xsrfCookieName: 'csrftoken'
});
const axiosDefault = axios.create();

export default ({method, url, data}) => {
  const instance = method === 'get' ? axiosDefault : axiosWithXsrf;
  if (data) {
    return instance[method](url, data);
  }
  return instance[method](url);
};
